export function initialDecisions(records){
  return Object.fromEntries(records.filter((r)=>['approved','rejected'].includes(r.verification)).map((r)=>[r.id,{
    id:r.id,action:r.extracted.action??(r.verification==='rejected'?'reject':'create'),values:r.extracted.values,
    siteId:r.extracted.siteId??r.evidence.identifierMatch,
    geocoding:r.evidence.geocoding??null,
  }]));
}
export function approveAll(records,current){
  const next={...current};
  for(const r of records){
    if(!['facility','shipment','dependency','product','carrier'].includes(r.extracted.kind))continue;
    const d=next[r.id]??{};
    next[r.id]={...d,id:r.id,values:d.values??r.extracted.values,
      action:r.extracted.kind==='facility'&&(d.siteId||r.evidence.identifierMatch)?'match':'create',
      siteId:d.siteId??r.evidence.identifierMatch,
    };
  }
  return next;
}
const present=(v)=>v!==null&&v!==undefined&&String(v).trim()!=='';
const coordinate=(v,max)=>present(v)&&Number.isFinite(Number(v))&&Math.abs(Number(v))<=max;
export function recordIssues(row,decision){
  if(!decision?.action)return ['Choose Approve record, Match existing site or Reject'];
  if(decision.action==='reject')return [];
  const v=decision.values??row.extracted.values,kind=row.extracted.kind,issues=[];
  if(!present(v.externalId))issues.push('Missing external ID');
  if(kind==='facility'){
    if(decision.action==='match'){if(!present(decision.siteId??row.evidence.identifierMatch))issues.push('Choose an existing site');}
    else{
      if(!present(v.name))issues.push('Missing site name');
      if(!coordinate(v.lat,90))issues.push('Enter latitude between -90 and 90');
      if(!coordinate(v.lon,180))issues.push('Enter longitude between -180 and 180');
    }
  }else if(kind==='shipment'){
    for(const side of ['origin','destination']){
      const lat=v[`${side}Lat`],lon=v[`${side}Lon`];
      if(present(lat)||present(lon)){
        if(!coordinate(lat,90)||!coordinate(lon,180))issues.push(`Enter valid ${side} latitude and longitude`);
      }else if(!present(v[side]))issues.push(`Provide ${side} facility ID or coordinates`);
    }
  }else if(kind==='dependency'){
    if(!present(v.upstream)||!present(v.downstream))issues.push('Provide upstream and downstream facility IDs');
  }else if(['product','carrier'].includes(kind)){if(!present(v.name))issues.push('Missing name');}
  else issues.push('Unsupported record type — reject this record');
  return issues;
}
